import { useCallback, useSyncExternalStore } from 'react';

/**
 * @deprecated Don't add new callers. Use CSS media queries for layout and
 * styling, and `<picture>` with `<source media>` for per-breakpoint images.
 * The server always renders the `false` branch, so a JS breakpoint shows the
 * wrong layout until hydration and then re-renders.
 *
 * Takes a max-width in px, or a full media query such as the `mq*` exports
 * from styled/tools/media-queries.
 */
const useClientSideMediaQuery = (query: number | string) => {
  const mediaQuery =
    typeof query === 'number' ? `(max-width:${query}px)` : query;

  const subscribe = useCallback(
    (onChange: () => void) => {
      const media = window.matchMedia(mediaQuery);
      media.addEventListener('change', onChange);
      return () => media.removeEventListener('change', onChange);
    },
    [mediaQuery],
  );

  // This returns false during hydration so it matches the server HTML, then
  // React re-renders with the real screen size instead of throwing out the page
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(mediaQuery).matches,
    () => false,
  );
};

export default useClientSideMediaQuery;
